import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import Image from '../../components/ContentfulImage';
import Placeholder from '../../components/Placeholder';

import {
  Wrapper,
  Title,
  FlexboxWrapper,
  Flexbox,
  Step,
  StepName,
  StepImage,
  StepTitle,
  StepDescription,
  StepProduct,
} from './TreatmentProcess.style';

const TreatmentProcess = ({ copy, steps, cImages }) => (
  <Wrapper>
    <Title>{copy.treatment_process || <Placeholder w="100px" h="20px" />}</Title>

    <FlexboxWrapper>
      <Flexbox length={steps.length}>
        {steps.map(step => (
          <Step key={step.entryId}>
            <StepName>{step.name || <Placeholder h="25px" w="50px" />}</StepName>
            <StepImage>
              {step.image ? (
                <Image src={step.image} options={{ w: '100%', size: [520, 820, 300, 345] }} />
              ) : (
                <Placeholder h="280px" w="100%" />
              )}
            </StepImage>
            {step.title && step.title !== '' ? <StepTitle>{step.title}</StepTitle> : null}
            {step.description && step.description !== '' ? <StepDescription>{step.description}</StepDescription> : null}
            {step.productsUsed && step.productsUsed.map(product => (
              <StepProduct key={product.entryId}>{product.name || null}</StepProduct>
            ))}
          </Step>
        ))}
      </Flexbox>
      {cImages !== undefined && (
        <Flexbox length={cImages.length}>
          {cImages.map(img => (
              <Step key={img.entryId || img.key}>
                <StepName>{img.title || <Placeholder h="25px" w="50px" />}</StepName>
                <StepImage>
                  {img.image ? (
                    <Image src={img.image} options={{ w: '100%', size: [520, 820, 300, 345] }} />
                  ) : (
                    <Placeholder h="280px" w="100%" />
                  )}
                </StepImage>
              </Step>
          ))}
        </Flexbox>
      )}
    </FlexboxWrapper>
  </Wrapper>
);

TreatmentProcess.defaultProps = {
  copy: {},
  steps: undefined,
  cImages: undefined,
};

TreatmentProcess.propTypes = {
  copy: PropTypes.shape(),
  steps: PropTypes.arrayOf(PropTypes.shape()),
  cImages: PropTypes.arrayOf(PropTypes.shape()),
};

const mapState = state => ({
  copy: state.siteOptions.siteCopyTreatmentPage,
});

export default connect(mapState)(TreatmentProcess);



// WEBPACK FOOTER //
// ./src/pages/TreatmentPage/TreatmentProcess.js